import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';

export interface IShippingLineExcerpt extends IBaseEntity {
    id?: number;
    name?: string;
    description?: string;
    cost?: number;
    shippingType?: string;
    departureTime?: string;
    durationMinutes?: number;
    shipsFrom?: string;
    shipsTo?: string;
    active?: boolean;
}

export class ShippingLineExcerpt extends BaseEntity implements IShippingLineExcerpt {
    public id?: number;
    public name?: string;
    public description?: string;
    public cost?: number;
    public shippingType?: string;
    public departureTime?: string;
    public durationMinutes?: number;
    public shipsFrom?: string;
    public shipsTo?: string;

    constructor(shippingLineExcerpt?) {
        super();
        if (shippingLineExcerpt) {
            this.id = shippingLineExcerpt.id;
            this.name = shippingLineExcerpt.name;
            this.description = shippingLineExcerpt.description;
            this.cost = shippingLineExcerpt.cost;
            this.shippingType = shippingLineExcerpt.shippingType;
            this.departureTime = shippingLineExcerpt.departureTime;
            this.durationMinutes = shippingLineExcerpt.durationMinutes;
            this.shipsFrom = shippingLineExcerpt.shipsFrom;
            this.shipsTo = shippingLineExcerpt.shipsTo;
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): IShippingLineExcerpt {
        return new ShippingLineExcerpt(this);
    }
}
